export type VrLoadPerfMeta = {
  allocateMs?: number;
  analysisType?: string;
  calciumSetSize?: number;
  chamberEnabled?: boolean;
  chamberSetSize?: number;
  cutVisibleSetSize?: number;
  dimX?: number;
  dimY?: number;
  dimZ?: number;
  elapsedMs?: number;
  epicardialSetSize?: number;
  fastPath?: boolean;
  flatLoop?: boolean;
  heartCutEnabled?: boolean;
  heartCut?: boolean;
  inputBytes?: number;
  labelVoxelCount?: number;
  loopMs?: number;
  lookupBuildMs?: number;
  mipBrightSetSize?: number;
  mipDarkSetSize?: number;
  mipEnabled?: boolean;
  outputBytes?: number;
  renderingQuality?: string;
  reusedMapper?: boolean;
  roundTripOverheadMs?: number;
  seriesId?: string;
  segVisibleSetSize?: number;
  transferOutputBytes?: number;
  useOriginalGeometry?: boolean;
  visibleKeyCount?: number;
  visibleMIP?: boolean;
  volumeName?: string;
  workerTotalMs?: number;
};

function nowMs() {
  return typeof performance !== 'undefined' && performance.now
    ? performance.now()
    : Date.now();
}

function roundMs(value: number) {
  return Math.round(value * 10) / 10;
}

export function logVrLoadPerf(
  stage: string,
  elapsedMs: number,
  meta: VrLoadPerfMeta = {},
) {
  const roundedElapsedMs = roundMs(elapsedMs);
  console.debug(`[vr-load-perf] ${stage} ${roundedElapsedMs}ms`, {
    ...meta,
    elapsedMs: roundedElapsedMs,
  });
}

export function startVrLoadPerf(stage: string, meta: VrLoadPerfMeta = {}) {
  const startedAt = nowMs();

  return (extraMeta: VrLoadPerfMeta = {}) => {
    const elapsedMs = nowMs() - startedAt;
    logVrLoadPerf(stage, elapsedMs, {
      ...meta,
      ...extraMeta,
    });
    return elapsedMs;
  };
}
